import { render, staticRenderFns } from "./IconLikeNull.vue?vue&type=template&id=ef8aaeb2&"
import script from "./IconLikeNull.vue?vue&type=script&lang=js&"
export * from "./IconLikeNull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports